const PROFILE = {
    INTELLIGENCE_SUBSCRIPTION: {
        event: 'Intelligence Subscription',
        eventProperties: {
            description: 'User selected to subscribe mineral intelligence',
            selectionType: 'subscribeEntity',
        },
    },
    INTELLIGENCE_UNSUBSCRIPTION: {
        event: 'Intelligence Unsubscription',
        eventProperties: {
            description: 'User selected to unsubscribe mineral intelligence',
            selectionType: 'unsubscribeEntity',
        },
    },
};

export default PROFILE;
